export default __webpack_public_path__ + "filter-tool-black-shape.png";